// extracted by mini-css-extract-plugin
export var actionPlaceholder = "_9k-3";
export var contentContainer = "_9k-0";
export var editorContainer = "_9k-1";
export var quillInputForm = "_9k-2";
export var zoneDivider = "_9k-4";